import { render } from "./taxes.vue?vue&type=template&id=25fea0b4"
import script from "./taxes.vue?vue&type=script&lang=js"
export * from "./taxes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__